module.exports = __webpack_public_path__ + "img/Pic_Bg_DB.81e200a9.png";